import { categories, categoryImages, categorySubtitles } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50" aria-labelledby="categories-heading">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Browse Categories
          </span>
          <h2 id="categories-heading" className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Shop by Category
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Find exactly what you are looking for with our carefully organized product categories
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative overflow-hidden rounded-xl aspect-[3/4] cursor-pointer"
            >
              <img
                src={categoryImages[cat.seq] || categoryImages["cat-other"]}
                alt={`${cat.name} category on Kakobuy Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <h3 className="text-background-50 font-semibold text-sm md:text-base whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-background-50/70 text-xs mt-1 leading-tight line-clamp-2">
                  {categorySubtitles[cat.seq] || "Discover trusted seller picks"}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}